<template>
    <div class="container py-4">
        <div class="row">
            <div class="col-8">
                <h2 class="mb-4">Update user</h2>
                <router-link :to="{name: 'userIndex'}" class="btn btn-outline-dark btn-sm mb-3">All users</router-link>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-md-6">
                <div class="alert alert-success" role="alert" v-if="success">
                    User successfully saved!
                </div>
                <div class="card">
                    <div class="card-body">
                        <form @submit.prevent="submit">
                            <div class="form-group">
                                <label for="name">Name*</label>
                                <input class="form-control" id="name" name="name"
                                       placeholder="Enter full name"
                                       type="text"
                                       v-bind:class="[this.name.validated ? this.name.valid ? 'is-valid' : 'is-invalid' : '']"
                                       v-model="form.name"
                                       v-validate="'required'">
                                <div class="invalid-feedback">{{ errors.first('name') }}</div>
                            </div>
                            <div class="form-group">
                                <label for="email">Email*</label>
                                <input class="form-control" id="email" name="email" placeholder="example@example.com"
                                       v-bind:class="[this.email.validated ? this.email.valid ? 'is-valid' : 'is-invalid' : '']"
                                       v-model="form.email"
                                       v-validate="'required|email'">
                                <div class="invalid-feedback">{{ errors.first('email') }}</div>
                            </div>
                            <div class="form-group">
                                <label for="email">Password*</label>
                                <input class="form-control" id="password" name="password" placeholder="Enter password"
                                       type="password"
                                       ref="password"
                                       v-bind:class="[this.password.validated ? this.password.valid ? 'is-valid' : 'is-invalid' : '']"
                                       v-model="form.password"
                                       v-validate="'required|min:8'">
                                <div class="invalid-feedback">{{ errors.first('password') }}</div>
                            </div>
                            <div class="form-group">
                                <label for="email">Retype password*</label>
                                <input class="form-control" id="c_password" name="c_password"
                                       data-vv-as="retype password"
                                       placeholder="Enter same password"
                                       type="password"
                                       v-bind:class="[this.c_password.validated ? this.c_password.valid ? 'is-valid' : 'is-invalid' : '']"
                                       v-model="form.c_password"
                                       v-validate="'required|confirmed:password'">
                                <div class="invalid-feedback">{{ errors.first('c_password') }}</div>
                            </div>
                            <div class="form-group">
                                <label for="role">Role</label>
                                <select id="role" class="form-control" v-model="form.roles">
                                    <option v-for="role in USER.roles"
                                            :value="role"
                                            :key="role">{{role}}</option>
                                </select>
                            </div>
                            <button class="btn btn-primary" type="submit">Save</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapFields} from 'vee-validate'
    import {mapGetters} from 'vuex'

    export default {
        name: 'userUpdate',
        data() {
            return {
                success: false,
                id: this.$route.params.id,
                form: {
                    roles: ''
                }
            }
        },
        computed: {
            ...mapFields(['name', 'email', 'password', 'c_password']),
            ...mapGetters(['USER'])
        },
        async mounted() {
            let user = await this.$store.dispatch('GET_USER', this.id)
            this.form = user
            this.form.roles = user.roles[0].name
        },
        methods: {
            submit() {
                //Moet in array voor backend
                this.form.roles = [this.form.roles]
                this.$store.dispatch('UPDATE_USER', this.form)
                this.success = true
            }
        }
    }
</script>
